module.exports = __webpack_public_path__ + "fba87613f62a75b2da4e303c18993352.svg";